import React from 'react';

import { Dialog } from "../../../../components/ui/dialog/dialog"
import { useDialogStore } from '../../stores/useDialogStore';
import { PartnerForm } from '../partner-form/partner-form';
import { QualityForm } from '../quality-form/quality-from';
// import { FeedbackForm } from '../../forms/FeedbackForm';
// import { EditProfileForm } from '../../forms/EditProfileForm';

export const DialogContainer = () => {
    const { isOpen, type, props, closeDialog } = useDialogStore();

    const renderContent = () => {
        switch (type) {
            case 'partner':
                return <PartnerForm />;
            case 'quality':
                return <QualityForm />;
            default:
                return null;
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={closeDialog} showCloseButton={true}>
            {renderContent()}
        </Dialog>
    );
};
